import template from './teamRequestsFilters.html';
import controller from './teamRequestsFilters.controller';
import './teamRequestsFilters.scss';

let teamRequestsFiltersComponent = {
  restrict: 'E',
  bindings: {
    onFilter : '&',
    filters : '<',
    exclusive: '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default teamRequestsFiltersComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestsFilters/teamRequestsFilters.component.js